// extracted by mini-css-extract-plugin
module.exports = {"Switcher":"Switcher_Switcher__NA47a","Disabled":"Switcher_Disabled__U9R_w","Input":"Switcher_Input__oJ_xO","Slider":"Switcher_Slider__1J6RU"};